// 분석 보고서 엑셀 내보내기 - exceljs(이미 의존성에 있음, MIT). 새 라이브러리 없음(계획 §6-5).
// 데이터는 서버 실행 API(RUN_SRC=EXPORT, 상한 적용)로 받은 결과만 쓴다 - 화면에 보이는 DOM을
// 그대로 찍는 방식이 아니다.
import ExcelJS from 'exceljs';

/**
 * @param result RptRunResultDto 모양({ columns, rows, total })
 * @param meta { tmplNm, rptNm, filtersText, generatedAt }
 */
export async function exportReportToExcel(result, meta) {
  const workbook = new ExcelJS.Workbook();

  const sheet = workbook.addWorksheet('결과');
  sheet.columns = result.columns.map((c) => ({ header: c.label, key: c.alias, width: 18 }));
  result.rows.forEach((row) => sheet.addRow(row));
  sheet.getRow(1).font = { bold: true };
  result.columns.forEach((c, idx) => {
    if (c.dataTyp === 'MONEY' || c.dataTyp === 'NUM') {
      sheet.getColumn(idx + 1).numFmt = '#,##0';
    }
  });

  const condSheet = workbook.addWorksheet('조건');
  condSheet.addRow(['템플릿', meta?.tmplNm || '']);
  condSheet.addRow(['보고서 이름', meta?.rptNm || '']);
  condSheet.addRow(['실행 시각', meta?.generatedAt || new Date().toISOString()]);
  condSheet.addRow(['조건', meta?.filtersText || '(없음)']);
  condSheet.addRow(['안내', '내 보기 범위 기준으로 실행한 결과입니다.']);
  condSheet.getColumn(1).width = 14;
  condSheet.getColumn(2).width = 60;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${(meta?.rptNm || 'report').replace(/[\\/:*?"<>|]/g, '_')}.xlsx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
